module.exports = __webpack_public_path__ + "img/pc-img4-618.31617468.png";